var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExitW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0332 14V24H26.0332V14H24.0332ZM16.0332 25.0476C16.0332 21.4406 18.1783 18.3271 21.2774 16.9094L20.4454 15.0906C16.6649 16.8201 14.0332 20.6254 14.0332 25.0476C14.0332 31.1009 18.9626 36 25.0332 36C31.1038 36 36.0332 31.1009 36.0332 25.0476C36.0332 20.6254 33.4015 16.8201 29.621 15.0906L28.789 16.9094C31.8881 18.3271 34.0332 21.4406 34.0332 25.0476C34.0332 29.9874 30.0083 34 25.0332 34C20.0581 34 16.0332 29.9874 16.0332 25.0476Z",
    fill: "#FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03516,
    y: 1,
    width: 47.9959,
    height: 48,
    rx: 23.9979,
    stroke: "#FFF",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitW);
export default __webpack_public_path__ + "static/media/exit_w.9755b8d64d5c4689f9f791eef1efe916.svg";
export { ForwardRef as ReactComponent };